<template>
  <div class="account_index">
    <div class="account_index_nav" @scroll="handleScroll" :style="titleBg">
      <navbar
        title="账号代运营"
        :lefticon="isScrollTop ? lefticon : lefticon1"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontsize="'1.8rem'"
        :titlecolor="titlecolor"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="box">
      <img
        class="banner"
        src="../../../assets/accountAgent/my/account_bg_top.png"
        alt=""
      />
      <van-col span="24" class="account_index_box">
        <div class="rule_box">
          <p class="tit_bg">
            <img src="../../../assets/accountAgent/my/rule_title.png" alt="" />
          </p>
          <p class="title">账号代运营规则</p>
          <div class="rule_content">
            <p class="con_title">
              <img src="../../../assets/accountAgent/my/circle_label.png" />
              项目背景
            </p>
            <p class="con">
              销巴会员提供一个账号，由具备运营资质的第三方公司负责该账号的运营推广，再由销巴平台自代运营服务生效后的第4个月开始给予销巴会员300元/月的红包补贴，作为销巴会员提供账号的项目收益。
            </p>
            <p class="con_title">
              <img src="../../../assets/accountAgent/my/circle_label.png" />
              押金收取
            </p>
            <p class="con">
              销巴会员开通代运营服务后，可申请认领一台智能手机，并向销巴平台缴纳2000元押金，缴纳的押金不享受积分赠送。如开通其他社交账号需要缴纳服务费的，缴费标准与申退规则以相关平台为准。
            </p>
            <p class="con_title">
              <img src="../../../assets/accountAgent/my/circle_label.png" />
              押金退回
            </p>
            <p class="con">
              销巴平台与会员均拥有单方面终止账号代运营服务的权利。如代运营服务终止，2000元押金原路退回或退回至会员余额。
            </p>
            <p class="con">
              关于认领手机的特别注意事项：在代运营服务终止后，销巴会员需将智能手机寄送至平台指定地址，并确保手机无软硬件损坏。如认领的手机在使用期间存在部分软硬件损坏，则平台退还部分押金（具体退还比例由专属客服与会员沟通协商）；如遗失手机，则平台按当时市场价格扣除保证金。
            </p>
            <p class="con_title">
              <img src="../../../assets/accountAgent/my/circle_label.png" />
              签订协议
            </p>
            <p class="con">
              销巴会员作为代运营账号的持有者，需与销巴平台、第三方公司在销巴生活APP上签订三方电子协议。协议详情，请移步相应页面查看。
            </p>
          </div>
        </div>
      </van-col>
    </van-row>
    <van-row class="account_index_footer">
      <van-col span="24">
        <span class="button">
          <btn
            :btntext="'去认领'"
            :btnwidth="'35.1rem'"
            :height="'5rem'"
            :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
            :borderradius="'2.5rem'"
            :btncolor="'#fff'"
            :fontsize="'1.7rem'"
            :btnShadow="'1px 5px 8px 0 rgba(249, 89, 27, 0.5)'"
            @btnClick="toSubmit"
          />
        </span>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/my/reback.png"),
      lefticon1: require("@/assets/accountAgent/common/back.png"),
      isScrollTop: true,
      titlecolor: "#ffffff",
      titleBg: { background: "rgba(255, 255, 255, 0)" },
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
  },
  mounted() {
    document
      .querySelector(".box")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    handleScroll() {
      //页面滚动
      var scrollTop = document.querySelector(".box").scrollTop;
      var point = Number(scrollTop / 44).toFixed(1);
      if (scrollTop > 44) {
        this.titleBg.background = "rgba(255, 255, 255, 1)";
        this.titlecolor = "#333333";
        this.isScrollTop = false;
      } else {
        if (point <= 0) {
          this.titleBg.background = "rgba(255, 255, 255, 0)";
          this.titlecolor = "#ffffff";
          this.isScrollTop = true;
        } else {
          this.titleBg.background = "rgba(255, 255, 255, " + point + ")";
          this.titlecolor = "#333333";
          this.isScrollTop = false;
        }
      }
    },
    goBack() {
      this.params("", "", "goBack");
    },
    toSubmit() {
      this.$router.push("/accountAgent/rule");
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.account_index {
  height: 100%;
  box-sizing: border-box;

  .account_index_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    // background-color: #f5f6f7;
    z-index: 3;
  }

  .box {
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .banner {
      width: 100%;
      height: 38rem;
      display: block;
    }

    .account_index_box {
      min-height: calc(100% - 38rem);
      height: auto;
      padding: 0 1.2rem 7.6rem;
      margin-top: -2px;
      background: -webkit-linear-gradient(
        #f2e2af 50%,
        #fed982 100%
      ); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(
        #f2e2af 50%,
        #fed982 100%
      ); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(
        #f2e2af 50%,
        #fed982 100%
      ); /* Firefox 3.6 - 15 */
      background: linear-gradient(
        #f2e2af 50%,
        #fed982 100%
      ); /* 标准的语法（必须放在最后） */
      // background: url(../../../assets/accountAgent/my/account_bg.png) no-repeat center center;
      // background-size: 100% 100%;

      .rule_box {
        height: auto;
        border-radius: 0.7rem;
        background: rgba(255, 255, 255, 0.39);
        padding: 0 1.5rem;
        color: #f9591b;
        font-size: 1.3rem;
        padding: 0 1.2rem 1.5rem;
        position: relative;

        .tit_bg {
          height: 2.9rem;
          text-align: center;

          img {
            display: inline-block;
            width: 18.5rem;
            height: 2.9rem;
          }
        }

        .title {
          color: #fff;
          text-align: center;
          height: 2.9rem;
          line-height: 2.9rem;
          font-size: 1.5rem;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
        }

        .rule_content {
          .con_title {
            font-size: 1.5rem;
            font-weight: 700;
            height: 2.4rem;
            line-height: 2.4rem;
            margin: 1.5rem 0 0.6rem;

            img {
              width: 1rem;
              margin-right: 0.6rem;
            }
          }

          .con {
            line-height: 2.4rem;
          }
        }
      }
    }
  }

  .account_index_footer {
    height: 6.7rem;
    padding: 0.7rem 1.2rem 1rem;
    color: #f9591b;
    text-align: right;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>


